<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted() {},
  methods: {},
}
</script>

<style>
html {
  -webkit-text-size-adjust: 100%; /* WebKit */
  -ms-text-size-adjust: 100%; /* IE */
  -moz-text-size-adjust: 100%; /* Firefox */
}

body {
  margin: 0;
}
#app {
  height: 100%;
}
</style>
